import styled, { css } from 'styled-components';
import { baseFontSize } from './font';

export const paragraphStyle = css`
  ${({ theme }): string => theme.mixins.margin({ top: 3.5, bottom: 3.5 })};
  color: ${({ theme }) => theme.commons.colors.gray800};
  ${baseFontSize};
`;

export const Paragraph = styled.p`
  ${paragraphStyle}
`;
